import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { UzurvDirectivesModule } from '@uzurv/core';
import { PaymentAccountSelectorModule } from '../../payment-account-selector/payment-account-selector.module';
import { NewPaymentDialogComponent } from './new-payment-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [NewPaymentDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    UzurvDirectivesModule,
    PaymentAccountSelectorModule,
    ReactiveFormsModule
  ],
  exports: [NewPaymentDialogComponent]
})
export class NewPaymentDialogModule {}
